import React, { useState } from 'react';
import { Form, Button, Container, Row, Col, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

function Login() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isRegistering, setIsRegistering] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (event) => {
        event.preventDefault();
        // setError('');
        // try {
        //     const endpoint = isRegistering ? 'https://marzdev.yourcrm.co.za/api/register' : 'https://marzdev.yourcrm.co.za/api/login';
        //     const response = await fetch(endpoint, {
        //         method: 'POST',
        //         headers: { 'Content-Type': 'application/json' },
        //         body: JSON.stringify({ username, password }),
        //     });

        //     const data = await response.json();

        //     if (!response.ok) {
        //         throw new Error(data.error || (isRegistering ? 'Registration failed' : 'Login failed'));
        //     }

        //     if (!isRegistering) {
        //         localStorage.setItem('token', data.token);
        //         navigate('/home'); 
        //     } else {
        //         alert('Registration successful! Please log in.');
        //         setIsRegistering(false);
        //     }
        // } catch (err) {
        //     setError(err.message);
        // }
        if (username === "admin") {
            localStorage.setItem('token', 'data.token');
            navigate('/home');
        }
    };

    return (
        <Container className="d-flex justify-content-center align-items-center vh-100">
            <Card style={{ width: '100%', maxWidth: '400px', padding: '20px', boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)' }}>
                <Card.Body>
                    <div className="text-center mb-3">
                        <img src={'/HeaderLogo.png'} alt="Logo" style={{ width: '200px' }} />
                    </div>
                    <h2 className=" mb-2 " style={{ fontSize: 20 }}>{isRegistering ? 'Register' : ''}</h2>
                    {error && <p className="text-danger text-center">{error}</p>}
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="formBasicUsername" className="mb-3">
                            <Form.Label>Username</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                required
                            />
                        </Form.Group>

                        <Form.Group controlId="formBasicPassword" className="mb-3">
                            <Form.Label>Password</Form.Label>
                            <Form.Control
                                type="password"
                                placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                        </Form.Group>

                        <Button variant="primary" type="submit" className="w-100">
                            {isRegistering ? 'Register' : 'Login'}
                        </Button>
                    </Form>
                    <Button
                        variant="link"
                        className="w-100 mt-2 text-center"
                        onClick={() => setIsRegistering(!isRegistering)}
                    >
                        {isRegistering ? 'Already have an account? Login' : 'Need an account? Register'}
                    </Button>
                </Card.Body>
            </Card>
        </Container>
    );
}

export default Login;